// 全局 Toast（独立 DOM 节点，不依赖任何 Vue 组件）
let el: HTMLDivElement | null = null;
let timer: ReturnType<typeof setTimeout> | null = null;

export function toast(msg: string, duration = 2600) {
  if (typeof document === 'undefined') return;
  if (!el) {
    el = document.createElement('div');
    el.className = 'toast';
    document.body.appendChild(el);
  }
  el.textContent = msg;
  el.classList.add('show');
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => el?.classList.remove('show'), duration);
}
